import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, useMediaQueries } from '@honda-canada/design-system-react';
import themeStyles from './SpecialOfferCard.styles';
import AnimatedLoader from '../AnimatedLoader';
const LoadingContainer = themeStyles.apply(Box, 'LoadingContainer');
const SpecialOffersLoader = () => {
    const { isMobile } = useMediaQueries();
    return (_jsx(LoadingContainer, { "data-testid": "cy-special-offers-loading-container", children: _jsx(AnimatedLoader, { isMobile: isMobile }) }));
};
export default SpecialOffersLoader;
